import { Button, Text } from "@chakra-ui/react";
import React from "react";

import { downloadFile } from "@nens/shared-utils";

export const ExplainFieldDataFile: React.FC = () => {
  return (
    <>
      <Text pb="5">
        Gebruik deze optie om de veldgegevens aan te leveren. Zorg ervoor dat u het format in het
        volgende template hanteert. Wanneer een waarde *onbekend* is dan vult u 'niet bepaald' in.
      </Text>
      <Button
        variant="primary"
        onClick={() =>
          downloadFile("/files/garFieldDataTemplate.xlsx", "garFieldDataTemplate.xlsx")
        }
      >
        Download Excel-template
      </Button>
    </>
  );
};
